import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "首页",
    component: HomeView,
  },
  {
    path: "/vue-OpenLayers",
    name: "vue+OpenLayers地图创建",
    component: () => import("../views/VueMapView.vue"),
  },
  {
    path: "/html-map-show",
    name: "html+OpenLayers地图创建",
    component: () => import("../views/HtmlMapView.vue"),
  },
  {
    path: "/vue-map-integration",
    name: "vue集成地图的两种方式",
    component: () => import("../views/VueMapIntegration.vue"),
  },
  {
    path: "/TileMap/offline-map",
    name: "离线瓦片地图",
    component: () => import("../views/XyzMapView.vue"),
  },
  {
    path: "/TileMap/gaode-map",
    name: "高德底图",
    component: () => import("../views/gaodeMapView.vue"),
  },
  // {
  //   path: "/TileMap/baidu-map",
  //   name: "百度底图",
  //   component: () => import("../views/baiduMapView.vue"),
  // },
  {
    path: "/TileMap/tianditu",
    name: "天地图",
    component: () => import("../views/tiandituView.vue"),
  },
  {
    path: "/TileMap/google-map",
    name: "google地图",
    component: () => import("../views/googleMapView.vue"),
  },
  {
    path: "/control/eagleEyeView",
    name: "鹰眼控件",
    component: () => import("../views/eagleEyeView.vue"),
  },
  {
    path: "/control/ScaleMapView",
    name: "缩放、比例尺控件",
    component: () => import("../views/ScaleMapView.vue"),
  },
  {
    path: "/control/FullScreenView",
    name: "全屏控件",
    component: () => import("../views/FullScreenView.vue"),
  },
  {
    path: "/control/networkView",
    name: "网格控件控件",
    component: () => import("../views/networkView.vue"),
  },
  {
    path: "/map-animation/noAnimationView",
    name: "无动画效果",
    component: () => import("../views/noAnimationView.vue"),
  },
  {
    path: "/map-animation/panToMapView",
    name: "平移效果",
    component: () => import("../views/panToMapView.vue"),
  },
  {
    path: "/map-animation/flyView",
    name: "飞行效果",
    component: () => import("../views/flyView.vue"),
  },
  {
    path: "/map-animation/bounceView",
    name: "弹簧跳跃和弹跳效果",
    component: () => import("../views/bounceView.vue"),
  },
  {
    path: "/map-event/MapLoaddingView",
    name: "地图加载事件",
    component: () => import("../views/MapLoaddingView.vue"),
  },
  {
    path: "/map-event/TileLoaddingView",
    name: "瓦片加载事件",
    component: () => import("../views/TileLoaddingView.vue"),
  },
  {
    path: "/map-event/MouseMoveView",
    name: "鼠标移动事件",
    component: () => import("../views/MouseMoveView.vue"),
  },
  {
    path: "/map-event/MouseClickView",
    name: "鼠标点击事件",
    component: () => import("../views/MouseClickView.vue"),
  },
  {
    path: "/Overlay/PointView",
    name: "点",
    component: () => import("../views/PointView.vue"),
  },
  {
    path: "/Overlay/PolygonDrawView",
    name: "多边形、圆形、线段",
    component: () => import("../views/PolygonDrawView.vue"),
  },
  {
    path: "/Overlay/GifDrawView",
    name: "gif动态图",
    component: () => import("../views/GifDrawView.vue"),
  },
  {
    path: "/Overlay/PointsView",
    name: "点聚合",
    component: () => import("../views/PointsView.vue"),
  },
  {
    path: "/Overlay/PopupView",
    name: "多点弹窗",
    component: () => import("../views/PopupView.vue"),
  },
  {
    path: "/HeatMapView",
    name: "热力图",
    component: () => import("../views/HeatMapView.vue"),
  },
  {
    path: "/EditAndDraw/DrawView",
    name: "图形绘制",
    component: () => import("../views/DrawView.vue"),
  },
  {
    path: "/EditAndDraw/GraffitiView",
    name: "涂鸦手绘",
    component: () => import("../views/GraffitiView.vue"),
  },
  // {
  //   path: '/OverlayData/WFS',
  //   name: 'WFS格式',
  //   component: () => import('../views/WFS.vue')
  // },
  {
    path: "/OverlayData/GeoJSON1",
    name: "GeoJSON数据添加矢量图",
    component: () => import("../views/GeoJSON1.vue"),
  },
  {
    path: "/OverlayData/GeoJSON2",
    name: "GeoJSON添加海量点数据",
    component: () => import("../views/GeoJSON2.vue"),
  },
  {
    path: "/OverlayData/GeoJSON3",
    name: "GeoJSON添加多边形、线段",
    component: () => import("../views/GeoJSON3.vue"),
  },
  {
    path: "/OverlayData/GeoJSON4",
    name: "加载静态GeoJSON数据",
    component: () => import("../views/GeoJSON4.vue"),
  },
  {
    path: "/OverlayData/WKT",
    name: "读取wkt格式数据",
    component: () => import("../views/WKT.vue"),
  },
  {
    path: "/OverlayData/TopoJson",
    name: "加载静态TopoJson数据",
    component: () => import("../views/TopoJson.vue"),
  },
  {
    path: "/animation/path",
    name: "运动轨迹",
    component: () => import("../views/path.vue"),
  },
  {
    path: "/animation/path2",
    name: "多车运动轨迹",
    component: () => import("../views/path2.vue"),
  },
  {
    path: "/example/electronicView",
    name: "电子围栏",
    component: () => import("../views/electronicView.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});
// 路由拦截器
router.beforeEach((to, from, next) => {
  if (to.path == from.path) {
    localStorage.removeItem("navActive");
  }
  next();
});
export default router;
